<template lang="pug">
  nuxt-child
</template>

<script>
import { ucFirst } from '~/utils/common';

export default {
  validate({ params, store }) {
    if (!/design|development|technology|business/i.test(params.lab)) {
      throw new Error('This lab does not exist');
    }

    store.commit('SET_THEME', params.lab);
    store.commit('SET_LOGO', {
      icon: 'logoIcon',
      text: `${ucFirst(params.lab)}`
    });

    return true;
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        // this.$store.commit('SET_THEME', route.params.lab);
        this.$store.commit('SET_LOGO', {
          icon: 'logoIcon',
          text: `${ucFirst(route.params.lab)}`
        });
      }
    }
  }
};
</script>
